<mat-tab-group
  #tabs
  mat-align-tabs="start"
  fzMatTabScrollToCenter
  [selectedIndex]="activeLinkIndex"
  (selectedIndexChange)="swipe($event)"
  (selectedTabChange)="selectedTabChange($event)"
  [class.disableGutters]="disableGutters"
>
  <mat-tab
    *ngFor="let link of links"
    [label]="link.name"
    [routerLink]="link.path"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
    [disabled]="link.disabled"
    [queryParams]="
      preserveQueryParams() ? queryParams()[link.path] || {} : undefined
    "
    [queryParamsHandling]="preserveQueryParams() ? 'merge' : undefined"
  ></mat-tab>
</mat-tab-group>
